import { render, staticRenderFns } from "./writeConfig.vue?vue&type=template&id=9833fe18&scoped=true&"
import script from "./writeConfig.vue?vue&type=script&lang=ts&"
export * from "./writeConfig.vue?vue&type=script&lang=ts&"
import style0 from "./writeConfig.vue?vue&type=style&index=0&id=9833fe18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9833fe18",
  null
  
)

export default component.exports